import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXLoginCheckEmail implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxLoginCheckEmailContainer";
    }
    render(){
        // console.log("LoginCheckEmail");

    }
}